<igx-input-group [style.width.%]="porcentaje" [style]="estilo" [type]="tipo">
  <!--Título inicial -->
  @if (mostrarTituloPrefix) {
    <igx-prefix>{{ prefixTitulo | translate }}:</igx-prefix>
  }

  <!--  Etiqueta  -->
  @if (mostrarEtiqueta) {
    <label igxLabel>{{ etiqueta | translate }}:</label>
  }
  <!--  Caja de entrada  -->
  <input #inputCatalogos id="inputCatalogos" [title]="valorDefault" igxInput [type]="tipoDato"
         [readOnly]="readOnlyInput" [disabled]="desactivarInput"
         [value]="valorDefault" style="width: 100%;text-transform:uppercase;"
         (keyup)="inputCatalogos.value = inputCatalogos.value.toUpperCase();" (input)="cambioValor(inputCatalogos.value)"
         (keydown)="customKeyDown($event, inputCatalogos.value)" [igxFocus]="true" [igxTextSelection]="true"/>
  <!--  boton de limpiar -->
  @if (mostrarBotonLimpiar(inputCatalogos.value)) {
    <igx-suffix (click)="limpiarInput(inputCatalogos)">
      <button title="{{ 'TOOLTIPS.LIMPIAR_FILTRO' | translate }}" igxIconButton="contained" igxRipple>
        <igx-icon>clear</igx-icon>
      </button>
    </igx-suffix>
  }
  <!-- boton buscar  -->
  <igx-suffix>
    <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained"
            (buttonClick)="onOpen()" [disabled]="desactivarInput" [hidden]="hiddenBtn">
      <igx-icon>search</igx-icon>
    </button>
  </igx-suffix>
</igx-input-group>
